var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadmapFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 44,
    viewBox: "0 0 36 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3644 2.84396C32.5367 3.72241 28.5618 5.31045 23.7093 5.31045C16.1631 5.31045 13.6477 2.276 3.58594 2.276V25.0345C13.6476 25.0345 16.163 28.0689 23.7093 28.0689C28.7963 28.0689 32.9189 26.3237 34.6141 25.4803C35.1278 25.2247 35.448 24.6992 35.448 24.1254V3.52871C35.4481 2.96917 34.8686 2.60162 34.3644 2.84396Z",
    fill: "#FA41A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6142 23.2045C32.9189 24.0479 28.7963 25.7931 23.7093 25.7931C20.999 25.7931 18.937 25.4019 16.9411 24.9006C10.8719 23.3761 6.62039 17.9143 6.62039 11.6566V2.37797C5.68625 2.31369 4.68327 2.27588 3.58594 2.27588V25.0345C4.68327 25.0345 5.68625 25.0723 6.62039 25.1365C14.2516 25.662 16.986 28.0689 23.7092 28.0689C28.796 28.0689 32.9184 26.3238 34.6138 25.4804C35.1278 25.2247 35.448 24.6993 35.448 24.1253V21.8494C35.448 22.4234 35.1279 22.9488 34.6142 23.2045Z",
    fill: "#D23C69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81418 0.0207831C1.06816 0.142127 0.551758 0.842689 0.551758 1.59842V43.2414C0.551758 43.6604 0.891469 44.0001 1.31041 44.0001H2.82764C3.24659 44.0001 3.5863 43.6604 3.5863 43.2414V1.51721C3.58621 0.595705 2.76473 -0.133904 1.81418 0.0207831Z",
    fill: "#5B5D6E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06898 43.2414V1.59835C2.06898 1.02815 2.36341 0.490096 2.82816 0.207792C2.53691 0.0384947 2.18663 -0.0398803 1.81418 0.0207056C1.06816 0.142221 0.551758 0.842698 0.551758 1.59835V43.2414C0.551758 43.6604 0.891469 44.0001 1.31041 44.0001H2.82764C2.40861 44 2.06898 43.6604 2.06898 43.2414Z",
    fill: "#464655"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapFlag);
export default __webpack_public_path__ + "static/media/roadmap-flag.0a3793b808cd9827500e5dfdb9dc7b8c.svg";
export { ForwardRef as ReactComponent };